export const GET_PROJECT_CAP_TABLE_ATTEMPT = 'GET_PROJECT_CAP_TABLE_ATTEMPT';
export type GET_PROJECT_CAP_TABLE_ATTEMPT = typeof GET_PROJECT_CAP_TABLE_ATTEMPT;

export const GET_PROJECT_CAP_TABLE_SUCCESS = 'GET_PROJECT_CAP_TABLE_SUCCESS';
export type GET_PROJECT_CAP_TABLE_SUCCESS = typeof GET_PROJECT_CAP_TABLE_SUCCESS;

export const GET_PROJECT_CAP_TABLE_FAILURE = 'GET_PROJECT_CAP_TABLE_FAILURE';
export type GET_PROJECT_CAP_TABLE_FAILURE = typeof GET_PROJECT_CAP_TABLE_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/project/cap-table/Types.tsx